module.exports = __webpack_public_path__ + "static/img/pic_rjyf_hzbz.5e706e82.png";